import type { ReactNode } from 'react';

type UseCaseSectionHeadProps = {
  eyebrow?: string;
  heading?: ReactNode;
  subheading?: string;
};

export function UseCaseSectionHead({ eyebrow, heading, subheading }: UseCaseSectionHeadProps) {
  return (
    <div className="sec-head reveal">
      {eyebrow && <span className="label-mono">- {eyebrow}</span>}
      {heading && <h2>{heading}</h2>}
      {subheading && <p className="sub">{subheading}</p>}
    </div>
  );
}
